import React from 'react';

const Admin = () => {
  return null;
};

export default Admin;